import React from 'react';

const GenerateSOW = () => (
  <div>
    <h2>Generate SOW</h2>
    <p>Create a new Statement of Work (SOW) here.</p>
  </div>
);

export default GenerateSOW;